import { render, staticRenderFns } from "./StatusHistory.vue?vue&type=template&id=30c6449a&scoped=true"
import script from "./StatusHistory.vue?vue&type=script&lang=js"
export * from "./StatusHistory.vue?vue&type=script&lang=js"
import style0 from "./StatusHistory.vue?vue&type=style&index=0&id=30c6449a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c6449a",
  null
  
)

export default component.exports